import type { LeadInstagramSubmit } from "@/api/router/lead-instagram/schemas";
import { PRETENSAO_OUTRO } from "@/lib/labels/lead-instagram";

import type { InstagramFormValues } from "./form";

export const InstagramPayload = {
	build(args: { draft: InstagramFormValues; hp: string }): LeadInstagramSubmit {
		const { draft, hp } = args;

		const text = (raw: string | undefined) => {
			const trimmed = (raw ?? "").trim();

			return trimmed === "" ? undefined : trimmed;
		};

		const ageDigits = (draft.age ?? "").replaceAll(/\D/gu, "");

		return {
			name: draft.name.trim(),
			phone: draft.phone.trim(),
			pretensao: draft.pretensao,
			pretensao_detail:
				draft.pretensao === PRETENSAO_OUTRO ? text(draft.pretensao_detail) : undefined,
			age: ageDigits === "" ? undefined : Number(ageDigits),
			city: text(draft.city),
			hp: text(hp),
		};
	},
};
